import "../../css/guest/home.css";
import { Tooltip } from "bootstrap";


document.addEventListener('DOMContentLoaded', (_e) => {
  for (const t of document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    new Tooltip(t);
});
